import React, { useState } from 'react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import Icon from './Icon';
import LoadingButton from './LoadingButton';
import DropdownMenu from './DropDownMenu';

export default ({sticky, ...props }) => {
     const { app, auth, errors } = usePage().props;
     const [menuOpened, setMenuOpened] = useState(false);
     const [langOpened, setLangOpened] = useState(false);
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          search: ''
     });
     let menu_control = [];
     for(let i = 0; i < app.menu.length; i++){
          menu_control.push({
               index: i,
               status: false
          });
     }
     const [menuControl, setMenuControl] = useState(menu_control);

     function handleMenuClick(e, index) {
          console.log('clicked', index);
          
          e.preventDefault();
          let menu_control = menuControl;
          menu_control[index].status = !menu_control[index].status;
          setMenuControl(menu_control);
          
     }

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          Inertia.post(route('site.product.search'), values).then(() => {
               // setSending(false);
          });
     }

     return (
          <header className={`${sticky?'fixed opacity-90 shadow-md':''} w-full flex-none z-40`}>
               <div className={`${sticky?'hidden':''} flex bg-gray-200 text-emerald-600 py-2`}>
                    <div className="container mx-auto">
                         <div className="container flex items-center px-4 text-xs md:px-4">
                              <Icon name={'location'} className={'fill-current w-4 h-4 mr-2'} /><span className="text-gray-500">{app.address} {app.phone}</span>
                         </div>
                    </div>
               </div>
               <div className={`${sticky?'hidden':''} w-full flex bg-white text-emerald-700 py-2`}>
                    <div className="container mx-auto">
                         <div className="flex items-center ml-4 text-xs">
                              <InertiaLink href={route('site')}>
                                   <img src={app.mhd.official} alt={app.name} className="h-24" />
                              </InertiaLink>
                         </div>
                    </div>
               </div>
               <nav className={`bg-emerald-700 px-2 lg:px-4`}>
                    <div className="justify-between hidden w-full md:flex">
                         <ul className="flex items-center py-2 space-x-1 lg:py-4 md:space-x-2">
                              <li key={`menua`}>
                                   <a href={route('site')} className={`h-full text-xs lg:text-sm font-light lg:font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site')?'bg-emerald-800 rounded':''} p-2`}>
                                        {app.caption.menu.home}
                                   </a>
                              </li>
                              {app.menu.map(({id, name, url, categories}, i)=>{
                                   return <li key={`menu${id}`}>
                                        {categories.length > 0 ? (<DropdownMenu items={categories} label={name} />) : (<a href={url} className={`h-full text-xs lg:text-sm font-light lg:font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site') ? 'bg-emerald-800 rounded' : ''} p-2`}>
                                             {name}
                                        </a>)}
                                   </li>
                              })}
                              <li key={`menub`}>
                                   <a href={route('site.demarcheur')} className={`h-full text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site.demarcheur')?'bg-emerald-800 font-semibold rounded':''} p-2`}>
                                        {app.caption.menu.sellers}
                                   </a>
                              </li>
                              <li key={`menuc`}>
                                   <a href={route('site.get.contact')} className={`h-full text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site.get.contact')?'bg-emerald-800 font-semibold rounded':''} p-2`}>
                                        {app.caption.menu.contact}
                                   </a>
                              </li>
                         </ul>

                         <div className="flex items-center justify-center">
                              <form onSubmit={handleSubmit}>
                                   <input type="text" name="search" value={values.search} onChange={handleChange} placeholder={app.caption.menu.search} className="p-1 bg-transparent border-b text-emerald-100 border-emerald-100 placeholder-emerald-100" />
                                   <LoadingButton type="submit" loading={sending} className="inline-flex text-emerald-100">
                                       <Icon name={'search'} className={'fill-current w-4 h-4 ml-2'} />
                                   </LoadingButton>
                              </form>
                         </div>

                         <div className="flex items-center">
                              <ul className="flex items-center space-x-2">
                                   <li key={`menum`}>
                                        <a href={route('blog.post.index')} className={`h-full flex text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site.cart.get')?'bg-emerald-800 font-semibold':''} p-2`}>
                                             Medias
                                        </a>
                                   </li>
                                   {!auth.user && (<li key={`menue`}>
                                        <a href={route('login')} className={`h-full text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('login')?'bg-emerald-800 font-semibold':''} p-2`}>
                                             {app.caption.menu.login}
                                        </a>
                                        {<a href={route('register')} className={`h-full text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('login')?'bg-emerald-800 font-semibold':''} p-2`}>
                                             {app.caption.menu.register}
                                        </a>}
                                   </li>)}
                                   {auth.user && (<li key={`menug`}>
                                        <a href={route('home')} className={`h-full text-xs lg:text-sm font-semibold bg-yellow-400 text-yellow-800 hover:bg-yellow-500 p-2`}>
                                             {app.caption.menu.logged_in}
                                        </a>
                                   </li>)}
                                   <li key={`menud`}>
                                        <a href={route('site.cart.get')} className={`h-full flex text-xs lg:text-sm font-semibold text-gray-100 uppercase hover:bg-emerald-800 rounded ${route().current('site.cart.get')?'bg-emerald-800 font-semibold':''} p-2`}>
                                             <Icon name={'shopping-cart'} className={'fill-current w-4 h-4 mr-2'} /> {app.cart.items && (<span className="items-center w-4 h-4 mx-auto my-auto ml-1 text-xs text-center rounded-full justify-items-center bg-emerald-200 text-emerald-800">{app.cart.items}</span>)}
                                        </a>
                                   </li>
                                   <li>
                                        <InertiaLink href={route('language.get', app.lang.code)} className="block p-2 text-xs text-gray-500">
                                             <img src={app.lang.flag} alt={app.lang.text} className="w-8" />
                                        </InertiaLink>
                                   </li>
                              </ul>
                         </div>
                    </div>

                    <div className="flex items-center justify-between w-full px-8 py-2 md:hidden md:px-12">
                         <div className="">
                              <div className="text-2xl font-bold text-gray-800 md:text-3xl">
                                   <InertiaLink href={route('site')}>
                                        {sticky && (<img src={app.mhd.logo_simple_mono} alt={app.name} className="h-6" />)}
                                   </InertiaLink>
                              </div>
                         </div>

                         <div className="flex items-center justify-center">
                              <form onSubmit={handleSubmit}>
                                   <input type="text" name="search" value={values.search} onChange={handleChange} placeholder={app.caption.menu.search} className="p-1 bg-transparent border-b text-emerald-100 border-emerald-100 placeholder-emerald-100" />
                                   <LoadingButton type="submit" loading={sending} className="inline-flex text-emerald-100">
                                       <Icon name={'search'} className={'fill-current w-4 h-4 ml-2'} />
                                   </LoadingButton>
                              </form>
                         </div>

                         <div className="">
                              <button onClick={()=>setMenuOpened(!menuOpened)} type="button" className={`block text-gray-100 hover:text-gray-700 focus:text-gray-700 focus:outline-none`}>
                                   <svg className={`h-6 w-6 fill-current text-gray-100`} viewBox="0 0 24 24">
                                        <path className="hidden" d="M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"/>
                                        <path d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
                                   </svg>
                              </button>
                         </div>
                    </div>
                    <div className={`w-full flex flex-col bg-emerald-700 text-gray-100 ${menuOpened ? '' : 'hidden'}`}>
                         <a href={route('site')} className={`font-medium hover:bg-emerald-800 ${route().current('site')?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>{app.caption.menu.home}</a>
                         {app.menu.map(({id, name})=>{
                              return <a key={`smenu-${id}`} href={route('site.product.category', name)} className={`font-medium text-gray-100 hover:bg-emerald-900 ${(route().params.category == name)?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>{name}</a>
                         })}
                         <a href={route('site.demarcheur')} className={`font-medium text-gray-100 hover:bg-emerald-800 ${route().current('site.demarcheur')?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>{app.caption.menu.sellers}</a>
                         <a href={route('site.get.contact')} className={`font-medium text-gray-100 hover:bg-emerald-800 ${route().current('site.get.contact')?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>{app.caption.menu.contact}</a>
                         <a href={route('blog.post.index')} className={`font-medium text-gray-100 hover:bg-emerald-800 ${route().current('blog.post.index')?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>Medias</a>
                         <a href={route('site.cart.get')} className={`font-medium text-gray-100 hover:bg-emerald-800 ${route().current('site.cart.get')?'bg-emerald-900 font-semibold':''} py-2 px-4 md:mx-2`}>{app.caption.menu.cart} {app.cart.items && (<span className="items-center w-4 h-4 p-1 mx-auto my-auto ml-1 text-xs text-center rounded-full justify-items-center bg-emerald-200 text-emerald-800">{app.cart.items}</span>)}</a>
                         {!auth.user && (<a href={route('login')} className={`font-medium text-gray-100 hover:bg-emerald-800 py-2 px-4 md:mx-2`}>{app.caption.menu.login}</a>)}
                         {!auth.user && (<a href={route('register')} className={`font-medium text-gray-100 hover:bg-emerald-800 py-2 px-4 md:mx-2`}>{app.caption.menu.register}</a>)}
                         {auth.user && (<a href={route('home')} className={`font-medium bg-yellow-400 text-yellow-800 hover:bg-yellow-600 py-2 px-4 md:mx-2`}>{app.caption.menu.logged_in}, {auth.user.first_name}</a>)}
                         <InertiaLink key={app.lang.code} href={route('language.get', app.lang.code)} className="block px-4 py-2">
                              <img src={app.lang.flag} alt={app.lang.text} className="w-4" />
                         </InertiaLink>
                    </div>
               </nav>
          </header>
     );
};
